import React from 'react'

interface ModalFooterProps {
  /** Left-aligned action area (e.g. destructive action) */
  left?: React.ReactNode
  /** Right-aligned actions (cancel + confirm) */
  children: React.ReactNode
}

const ModalFooter: React.FC<ModalFooterProps> = ({ left, children }) => (
  <div className="flex items-center justify-between pt-4 mt-4 border-t border-gray-200 dark:border-gray-700 gap-3">
    <div>{left ?? null}</div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
)

export default ModalFooter
